/* V7: read-only interface enhancements. No catalog, cart, history, storage or
   customer-data writes. Component cleanup is compatible with the theme editor. */
(() => {
  'use strict';
  const modifiedClick = event => event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
  const directSummary = detail => [...detail.children].find(child => child.tagName === 'SUMMARY');
  class DevocioneMasthead extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.menu = this.querySelector('[data-dv7-menu]');
      this.topDetails = [...this.querySelectorAll('[data-dv7-top-detail]')];
      this.breakpoint = matchMedia('(min-width:990px)');
      const refreshMenu = () => {
        const open = Boolean(this.menu?.open);
        this.classList.toggle('dv7-menu-open', open);
        const summary = this.menu && directSummary(this.menu);
        summary?.setAttribute('aria-expanded', String(open));
        summary?.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
        const viewportHeight = window.visualViewport?.height || window.innerHeight;
        const bottom = this.getBoundingClientRect().bottom;
        this.style.setProperty('--dv7-available-height', `${Math.max(140,viewportHeight - Math.max(0,bottom) - 16)}px`);
      };
      this.close = (focus = false) => {
        const wasOpen = this.menu?.open;
        this.topDetails.forEach(detail => {detail.open = false; directSummary(detail)?.setAttribute('aria-expanded','false');});
        refreshMenu();
        if (focus && wasOpen) directSummary(this.menu)?.focus({preventScroll:true});
      };
      this.topDetails.forEach(detail => {
        directSummary(detail)?.setAttribute('aria-expanded', String(detail.open));
        detail.addEventListener('toggle', () => {
          if (detail.open) {
            this.topDetails.forEach(other => {if (other !== detail) other.open = false;});
            if (detail !== this.menu) detail.querySelector('input[type=search]')?.focus({preventScroll:true});
          }
          directSummary(detail)?.setAttribute('aria-expanded',String(detail.open));
          refreshMenu();
        }, options);
      });
      this.addEventListener('click', event => {
        if (!(event.target instanceof Element)) return;
        const closeButton = event.target.closest('[data-dv7-close],[data-dv6-close]');
        if (closeButton) {
          const parent = closeButton.closest('[data-dv7-top-detail]');
          if (parent) {parent.open=false; directSummary(parent)?.focus({preventScroll:true});}
          refreshMenu();return;
        }
        if (event.target.closest('a[href]') && !modifiedClick(event)) this.close();
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const candidates = [...this.querySelectorAll('details[open]')].reverse();
        const detail = candidates.find(item => item.contains(document.activeElement)) || this.topDetails.find(item => item.open);
        if (detail) {event.preventDefault(); event.stopPropagation(); detail.open=false; directSummary(detail)?.focus({preventScroll:true}); refreshMenu();}
      }, options);
      document.addEventListener('pointerdown', event => {if(!this.contains(event.target)) this.close();}, options);
      document.addEventListener('focusin', event => {if(!this.contains(event.target)) this.close();}, options);
      this.breakpoint.addEventListener('change', () => {if(this.breakpoint.matches) this.close();refreshMenu();}, options);
      window.addEventListener('resize',refreshMenu,options);
      window.visualViewport?.addEventListener('resize',refreshMenu,options);
      document.addEventListener('shopify:section:select',event => {if(event.target.contains(this)) refreshMenu();},options);
      refreshMenu();
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;}
  }
  if (!customElements.get('dv7-masthead')) customElements.define('dv7-masthead',DevocioneMasthead);

  function preservePreview(scope=document){
    const preview=new URL(location.href).searchParams.get('preview_theme_id');
    if(!preview||!/^\d+$/.test(preview))return;
    scope.querySelectorAll?.('a[data-dv7-promotion-link]').forEach(link=>{
      const url=new URL(link.href,location.href);if(url.origin!==location.origin)return;
      url.searchParams.set('preview_theme_id',preview);link.href=url.toString();
    });
  }
  preservePreview();
  document.addEventListener('shopify:section:load',event=>preservePreview(event.target));
})();
